var module = angular.module('octopusApp.projects');

module.controller('ProjectDeploymentCreateController', function ($scope, $q, $timeout, $location, $stateParams, projectState, busy, pageTitle, octopusLog, octopusRepository, octopusPermissionSet) {
    var machinesPromise;
    var isLoading = $scope.isLoading = busy.create();
    var isPreviewing = $scope.isPreviewing = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    $scope.allTenants = [];
    var projectId = $stateParams.projectId;
    var goal = $stateParams["goal"];
    var previousDeploymentId = $stateParams["previousId"];
    var releaseVersion = $stateParams.version;
    var tenantIds = $location.search().tenantIds; //tenantIds
    var tags = $location.search().tags;

    if (goal === "to") {
        previousDeploymentId = null;
    }
    $scope.view = {
        queueTime: null,
        queueTimeExpiry: null,
        deploymentType: 'normal',
        showAdvanced: $scope.$storage.alwaysShowAdvancedDeploymentOptions,
        selectedEnvironments: [],
        selectedTenants: [],
        selectedTenantTags: [],
        resultantTenants: [],
        resultantTenantCount: 0,
        loadMatchingTenants: function(){ },
        modifyDestination: true,
        selectedSpecificMachineOption: 'all',
        includeSpecificMachineIds: [],
        excludeSpecificMachineIds: []
    };
    $scope.previous = null;
    $scope.canSkipAll = false;
    $scope.latest = {};
    $scope.errors = {};
    $scope.success = {};

    $scope.canDeploy = function canDeploy(){

        var isStandardView = !$scope.view.showAdvanced;
        var isNormalDeploymentWithEnvironmentSelected = ($scope.view.deploymentType === 'normal' && $scope.view.selectedEnvironments.length > 0);
        var isTenantDeploymentWithTenantsSelected = ($scope.view.deploymentType === 'tenant' && ($scope.view.selectedTenants.length + $scope.view.selectedTenantTags.length > 0));

        return isStandardView && (isNormalDeploymentWithEnvironmentSelected || isTenantDeploymentWithTenantsSelected);
    };

    function getPromoteToEnvironments() {

        $scope.promoteTo = $scope.template.PromoteTo;

        $scope.promotionsMap = {};

        _.each($scope.template.PromoteTo, function(environmentPromotion){
           $scope.promotionsMap[environmentPromotion.Id] = environmentPromotion;
        });

        _.each($scope.template.TenantPromotions, function(tenantPromotion){
            $scope.promotionsMap[tenantPromotion.Id] = tenantPromotion;
        });
    }

    $scope.channel = null;
    $scope.isMultitenancyEnabled = !!octopusRepository.Tenants;
    $scope.requireTenantedDeployment = false;

    function init() {
        var load = function() {

            $scope.$watchCollection(function(){ return $scope.view.selectedEnvironments; }, function() { $scope.refreshPreview(); });
            $scope.$watchCollection(function() { return $scope.view.resultantTenants; }, function() { $scope.refreshPreview(); });
            $scope.$watch(function() { return $scope.view.deploymentType; }, function() { $scope.refreshPreview(); });
            $scope.$watchCollection(function() { return $scope.view.selectedSpecificMachineOption; }, function() { updateSpecificMachineSelection(); });
            $scope.$watchCollection(function() { return $scope.view.includeSpecificMachineIds; }, function() { updateSpecificMachineSelection(); });
            $scope.$watchCollection(function() { return $scope.view.excludeSpecificMachineIds; }, function() { updateSpecificMachineSelection(); });

            // Only for tenants
            var tenantsLoader = (octopusRepository.Tenants ? octopusRepository.Tenants.all() : $q.resolve([])).then(function (tenants) {
                $scope.allTenants = tenants;
                return tenants;
            });

            var projectLoader = projectState.load().then(function(project) {
                $scope.project = project;
                $scope.allowDeploymentsToNoTargets = project.ProjectConnectivityPolicy.AllowDeploymentsToNoTargets;
                $scope.requireTenantedDeployment = project.RequireTenantedDeployment;
                if ($scope.requireTenantedDeployment) {
                    $scope.view.deploymentType = 'tenant';
                }

                return project;
            });
      
            isLoading.promise(tenantsLoader);
            isLoading.promise(projectLoader.then(function (project) {

                return octopusRepository.Projects.getReleaseByVersion(project, releaseVersion).then(function (release) {

                    // Only for tenants
                    $scope.canPerformTenantedDeployments = function canPerformTenantedDeployments() {
                        return $scope.project.TenantedDeploymentMode === 'TenantedOrUntenanted' || $scope.project.TenantedDeploymentMode === 'Tenanted';
                    };

                    isLoading.promise(octopusRepository.Channels.get(release.ChannelId).then(function (channel) {
                        $scope.channel = channel;
                    }));

                    isLoading.promise(octopusRepository.Projects.getTriggers($scope.project).then(function (triggers) {
                        $scope.triggers = triggers;
                    }));

                    return octopusRepository.Releases.getDeploymentTemplate(release).then(function (template) {

                        if ($scope.project.TenantedDeploymentMode === 'Tenanted') {
                            $scope.view.deploymentType = 'tenant';
                            $scope.requireTenantedDeployment = true;
                        }

                        $scope.release = release;
                        $scope.template = template;
                        $scope.promotionDictionary = {};
                        if (template.PromoteTo.length === 0 && template.TenantPromotions.length === 0) {
                            // User can see empty "environments" list
                            return;
                        }

                        getPromoteToEnvironments();

                        $scope.deployment = {
                            ReleaseId: release.Id,
                            UseGuidedFailure: true,
                            SkipActions: [],
                            SpecificMachineIds: [],
                            ForcePackageDownload: $scope.previous ? $scope.previous.ForcePackageDownload : false
                        };

                        if ($scope.previous && goal === "try-again") {
                            $scope.view.selectedEnvironments.push($scope.previous.EnvironmentId);
                            $scope.view.modifyDestination = false;
                            if ($scope.previous.TenantId) {
                                $scope.view.deploymentType = 'tenant';
                                $scope.view.selectedTenants = [$scope.previous.TenantId];
                            }
                        }

                        if (goal === "to") {
                            _.each(($stateParams["previousId"] || "").split(','), function (id) {
                                $scope.view.selectedEnvironments.push(id);
                            });
                            if (tenantIds) {
                                $scope.view.deploymentType = 'tenant';
                                if (typeof tenantIds === 'string') {
                                    tenantIds = [tenantIds];
                                }
                                $scope.view.selectedTenants = tenantIds;
                            }

                            if (tags) {
                                if (typeof tags === 'string') {
                                    tags = [tags];
                                }
                                $scope.view.selectedTenantTags = tags;
                                $scope.view.deploymentType = 'tenant';
                            }
                        }

                        if ($scope.view.selectedEnvironments.length === 1) {
                            $scope.view.selectedEnvironment = $scope.view.selectedEnvironments[0];
                        }


                        if ($scope.view.selectedEnvironments.length > 0) {
                            $scope.view.modifyDestination = false;
                            $scope.refreshPreview();
                        }
                    });
                });
            }));
        };

        octopusPermissionSet.isAuthorized({ permission: 'MachineView', projectId: projectId, environmentId: '*' }).then(function(yn) {
            if (yn) {
                machinesPromise = octopusRepository.Machines.all();
                isLoading.promise(machinesPromise);
            }
        });

        if (previousDeploymentId) {
            isLoading.promise(octopusRepository.Deployments.get(previousDeploymentId).then(function (previous) {
                $scope.previous = previous;
                load();
            }));
        } else {
            load();
        }
    }

    $scope.skipAll = function () {
        _.each($scope.steps, function (step) {
            if (step.details.CanBeSkipped && !step.details.IsDisabled) {
                step.enable = false;
            }
        });
    };

    $scope.skipNone = function () {
        _.each($scope.steps, function (step) {
            if (step.details.CanBeSkipped && !step.details.IsDisabled) {
                step.enable = true;
            }
        });
    };

    $scope.showSkippedStepsWillAffectAutoDeploymentsWarning = function() {
        var hasTriggers = $scope.triggers && $scope.triggers.Items.length > 0;

        var hasSkippedSteps = $scope.steps && _.any($scope.steps, function(s) {
                return s.enable === false;
            });

        return hasTriggers && hasSkippedSteps;
    };

    $scope.refreshPreview = function() {
        if ($scope.view.selectedEnvironments.length === 0) {
            return;
        }

        $scope.pendingInterruptions = [];
        _.each($scope.view.selectedEnvironments, function(environmentId) {
            var options = { environment: environmentId, project: $scope.project.Id, active: true, hasPendingInterruptions: true };
            
            octopusRepository.Tasks.filter(options).then(function (interruptionTasks) {
                _.each(interruptionTasks.Items, function(task) { 
                    // NOTE: need to de-dup because refreshPreview occurs multiple times on intial load...
                    if(!_.some($scope.pendingInterruptions, function(a) { return a.Id == task.Id; } )){
                        $scope.pendingInterruptions.push(task);
                    }
                });
            });
        });

        var promises = [];

        // If tenants have been selected then we use the tenant-environment deployment-previews
        if ($scope.view.resultantTenants && $scope.view.resultantTenants.length > 0)
        {
            promises = getTenantEnvironmentPreviews($scope.promotionsMap, $scope.view.resultantTenants, $scope.view.selectedEnvironments);
        } else {
            // Otherwise it is an un-tenanted deployment and we use the environment promotions
            promises = _.map($scope.view.selectedEnvironments, function(e) {
                return octopusRepository.Releases.getDeploymentPreview($scope.promotionsMap[e]);
            });
        }

        isPreviewing.promise($q.all(promises).then(function (previews) {

            var stepGroups = _.chain(previews).map(function (p) {
                return p.StepsToExecute;
            }).flatten().groupBy('ActionId').value();

            $scope.steps = [];

            $scope.steps = _.chain(stepGroups).map(function (steps, actionId) {
                var wasSkipped = $scope.previous ? $scope.previous.SkipActions.indexOf(actionId) >= 0 : false;
                var firstStep = steps[0];
                var applicable = false;
                _.each(steps, function (step) {
                    if (!step.HasNoApplicableMachines) {
                        applicable = true;
                    }
                });

                var unavailableIds = {};
                var unavailableMachines = _.chain(steps)
                      .map(function (s) {
                          return s.UnavailableMachines;
                      })
                      .flatten()
                      .uniq(function (m) {
                          return m.Id;
                      })
                      .each(function (m) {
                          unavailableIds[m.Id] = m;
                      })
                      .value();

                var allMachines = _.chain(steps)
                      .map(function (s) {
                          return s.Machines;
                      })
                      .flatten()
                      .uniq(function (m) {
                          return m.Id;
                      })
                      .each(function (m) {
                          if (unavailableIds[m.Id]) {
                              m.isUnavailable = true;
                          }
                      })
                      .value();

                var hasOldCalamariVersion = _.any(allMachines, function (m) {
                    return !m.HasLatestCalamari;
                });

                return {
                    details: {
                        ActionId: firstStep.ActionId,
                        ActionName: firstStep.ActionName,
                        ActionNumber: firstStep.ActionNumber,
                        CanBeSkipped: firstStep.CanBeSkipped,
                        IsDisabled: firstStep.IsDisabled,
                        Machines: allMachines,
                        UnavailableMachines: unavailableMachines,
                        HasNoApplicableMachines: !applicable,
                        HasOldCalamariVersion: hasOldCalamariVersion
                    },
                    enable: !wasSkipped || !firstStep.IsDisabled
                };
            }).sortBy(function (s) {
                return parseInt(s.details.ActionNumber);
            }).value();

            $scope.canSkipAll = $scope.steps.length >= 3;
            $scope.specificMachines = [];
            $scope.excludedMachines = [];
            resetSpecificMachineSelections();

            $scope.machinesApplicableToThisDeployment = [];
            octopusPermissionSet.isAuthorized({ permission: 'MachineView', projectId: projectId, environmentId: '*' }).then(function(yn) {
                if (yn) {
                    machinesPromise.then(function (availableMachines) {
                        $scope.machinesApplicableToThisDeployment = availableMachines.filter(function (machine) {
                            if ($scope.view.deploymentType === 'tenant') {
                                return ($scope.view.resultantTenants && $scope.view.resultantTenants.length > 0 && $scope.view.resultantTenants.filter(function (tenantId) {
                                        return machine.TenantIds.indexOf(tenantId) >= 0;
                                    }).length > 0)
                                    || ($scope.view.selectedTenantTags && $scope.view.selectedTenantTags.length > 0 && $scope.view.selectedTenantTags.filter(function (tag) {
                                        return machine.TenantTags.indexOf(tag) >= 0;
                                    }).length > 0) 
                                    || machine.TenantTags.length !== 0;
                            }

                            return (machine.TenantIds.length === 0 && machine.TenantTags.length === 0);
                        });

                        $scope.specificMachines = $scope.machinesApplicableToThisDeployment.filter(function (machine) {
                            return $scope.steps.filter(function (step) {
                                return step.details.Machines.filter(function (stepMachine) {
                                    return stepMachine.Id === machine.Id;
                                }).length > 0;
                            }).length > 0;
                        });
                    });
                }
            });
            $scope.unavailableMachines = _.chain($scope.steps).map(function (s) {
                return s.details.UnavailableMachines;
            }).flatten().uniq(function (m) {
                return m.Id;
            }).value();
            $scope.deployment.SpecificMachineIds = [];
            $scope.deployment.ExcludedMachineIds = [];
            $scope.deployment.UseGuidedFailure = _.any(previews, function (p) {
                return p.UseGuidedFailureModeByDefault;
            });

            var hasWarnings = false;
            _.each($scope.steps, function (step) {
                if (step.details.HasNoApplicableMachines) {
                    hasWarnings = true;
                }
            });

            if (hasWarnings) {
                $scope.view.showAdvanced = true;
            }

            $scope.hasMachineWithOldCalamariVersion = false;
            _.each($scope.steps, function (step) {
                if (step.details.HasOldCalamariVersion) {
                    $scope.hasMachineWithOldCalamariVersion = true;
                }
            });

            var form = {Elements: [], Values: {}};
            _.each(previews, function (preview) {
                if (!preview || !preview.Form) {
                    return;
                }

                if (preview.Form.Values) {
                    _.each(preview.Form.Values, function (v, k) {
                        form.Values[k] = v;
                    });
                }

                if (preview.Form.Elements) {
                    _.each(preview.Form.Elements, function (c) {
                        if (!_.find(form.Elements, function (e) {
                            return e.Name === c.Name;
                        })) {
                            form.Elements.push(c);
                        }
                    });
                }
            });

            $scope.preview = {Form: form};
        }));
    };
    
    $scope.isMachineIncludedInDeployment = function (id) {
        if ($scope.deployment.SpecificMachineIds.length > 0 && $scope.deployment.SpecificMachineIds.indexOf(id) < 0)
        {
            return false;
        }

        if ($scope.deployment.ExcludedMachineIds.length > 0 && $scope.deployment.ExcludedMachineIds.indexOf(id) >= 0)
        {
            return false;
        }

        return true;
    };

    $scope.isMachineApplicableToThisDeployment = function (id) {
        return $scope.machinesApplicableToThisDeployment.length !== 0 
            && _.find($scope.machinesApplicableToThisDeployment, function (machine) { return machine.Id === id; });
    };

    $scope.canSelectSpecificMachines = function () {
        return $scope.view.selectedEnvironments.length === 1 && $scope.deployment && $scope.specificMachines;
    };

    function updateSpecificMachineSelection() {
        if (!$scope.canSelectSpecificMachines()) {
            resetSpecificMachineSelections();
            return;
        }

        if ($scope.view.selectedSpecificMachineOption === 'all') {
            $scope.deployment.SpecificMachineIds = [];
            $scope.deployment.ExcludedMachineIds = [];
            return;
        }

        var allApplicableMachineIds = _.map($scope.specificMachines, function(m) { return m.Id; });
        
        if ($scope.view.selectedSpecificMachineOption === 'include') {
            $scope.deployment.SpecificMachineIds = ($scope.view.includeSpecificMachineIds.length > 0)
                ? $scope.view.includeSpecificMachineIds
                : allApplicableMachineIds;

            $scope.deployment.ExcludedMachineIds = [];
            return;
        }
        
        if ($scope.view.selectedSpecificMachineOption === 'exclude') {
            $scope.deployment.SpecificMachineIds = [];
            $scope.deployment.ExcludedMachineIds = $scope.view.excludeSpecificMachineIds;
            return;
        }
        
        // If in doubt just reset everything...
        resetSpecificMachineSelections();
    }
    
    $scope.onlyIncludeAvailableMachines = function() {
        var unavailableMachineIds = _.map($scope.unavailableMachines, function(m) { return m.Id; });
        $scope.view.selectedSpecificMachineOption = 'exclude';
        $scope.view.excludeSpecificMachineIds = _.union($scope.view.excludeSpecificMachineIds, unavailableMachineIds);
        updateSpecificMachineSelection();
    };

    $scope.isTargetingAnyUnavailableMachines = function() {
        if (!$scope.unavailableMachines || !$scope.deployment.SpecificMachineIds) {
            return false;
        }

        var unavailableMachineIds = _.map($scope.unavailableMachines, function(m) { return m.Id; });

        return ($scope.deployment.SpecificMachineIds.length === 0 && unavailableMachineIds.length > 0)
            || (_.intersection($scope.deployment.SpecificMachineIds, unavailableMachineIds).length > 0);
    };

    function resetSpecificMachineSelections() {
        if ($scope.view) {
            $scope.view.selectedSpecificMachineOption = 'all';
            $scope.view.includeSpecificMachineIds = [];
            $scope.view.excludeSpecificMachineIds = [];
        }
        if ($scope.deployment) {
            $scope.deployment.SpecificMachineIds = [];
            $scope.deployment.ExcludedMachineIds = [];
        }
    }

    $scope.newDeployments = {};

    $scope.deploy = function () {
        $scope.view.modifyDestination = false;

        var deployments;
        if ($scope.view.deploymentType === "normal") {
            deployments = createEnvironmentDeployments();
        } else if ($scope.view.deploymentType === "tenant") {
            deployments = createTenantDeployments();
        } else {
            throw "Unknown Deployment Type";
        }

        isSaving.promise(deployments.then(function(tasks){
            return $q.all(tasks.map(function(item) {
                return item.deployment.then(function(deployment) {
                    setDeploymentState(item.environmentId, item.tenantId, {state: 'success', deployment: deployment});
                    checkCanRedirect();
                }, function(error){
                    setDeploymentState(item.environmentId, item.tenantId, {state: 'error', error: error});
                });
            }));
        }).then(checkCanRedirect));

        function checkCanRedirect() {
            var first, last;
            for (var environmentId in $scope.newDeployments) {
                for (var tenantId in $scope.newDeployments[environmentId]) {
                    first = first || $scope.newDeployments[environmentId][tenantId];
                    last =  $scope.newDeployments[environmentId][tenantId];
                    if ($scope.newDeployments[environmentId][tenantId].state !== 'success'){
                        return;
                    }
                }
            }

            if (!first) { //none have returned
                return;
            }

            if (first === last) { // only one request
                $location.path('/projects/' + $scope.project.Slug + '/releases/' + $scope.release.Version + '/deployments/' + last.deployment.Id);
            } else {
                $location.path('/projects/' + $scope.project.Slug + '/releases/' + $scope.release.Version);
            }
        }
    };

    function setDeploymentState(environmentId, tenantId, state){
        $scope.newDeployments[environmentId] = $scope.newDeployments[environmentId] || {};
        $scope.newDeployments[environmentId][tenantId] = state;
    }

    function createEnvironmentDeployments(){
      var tenantId = null;

      return $q.resolve($scope.view.selectedEnvironments.filter(function(environmentId){
          return !$scope.newDeployments[environmentId] ||
              !$scope.newDeployments[environmentId][tenantId] ||
              $scope.newDeployments[environmentId][tenantId].state !== "success";
      }).map(function(environmentId) {
          return createDeployment(environmentId, tenantId);
      }));
    }

    function createDeployment(environmentId, tenantId) {
        var deployment = {
            ReleaseId: $scope.release.Id,
            EnvironmentId: environmentId,
            TenantId: tenantId,
            SkipActions: $scope.steps.filter(function (step) {
                return !step.enable && !step.details.IsDisabled;
            }).map(function (step) {
                return step.details.ActionId;
            }),
            QueueTime: $scope.view.queueTime,
            QueueTimeExpiry: $scope.view.queueTimeExpiry,
            FormValues: $scope.preview.Form.Values,
            ForcePackageDownload: $scope.deployment.ForcePackageDownload,
            UseGuidedFailure: $scope.deployment.UseGuidedFailure,
            SpecificMachineIds: $scope.deployment.SpecificMachineIds,
            ExcludedMachineIds: $scope.deployment.ExcludedMachineIds,
            ForcePackageRedeployment: $scope.deployment.ForcePackageRedeployment
        };

        setDeploymentState(environmentId, tenantId, {state: 'running'});

        return {
            tenantId: tenantId,
            environmentId: environmentId,
            deployment: octopusRepository.Deployments.create(deployment)
        };
    }

    function createTenantDeployments(){
        var environmentId = $scope.view.selectedEnvironments[0];

        return getTenants().then(function(tenantIds) {
            return tenantIds.filter(function(tenantId){
                return !$scope.newDeployments[environmentId] ||
                !$scope.newDeployments[environmentId][tenantId] ||
                $scope.newDeployments[environmentId][tenantId].state !== "success";
            }).map(function (tenantId) {
                return createDeployment(environmentId, tenantId);
            });
        });

        function getTenants() {
            if ($scope.view.selectedTenantTags.length !== 0) {
                return $scope.view.loadMatchingTenants();
            } else {
                return $q.resolve($scope.view.selectedTenants);
            }
        }
    }

    // Returns promises for deployment-previews for the combination of selected tenants and environments
    function getTenantEnvironmentPreviews(availablePromotions, selectedTenants, selectedEnvironments) {
        return _.chain(selectedTenants)
            .map(function(t) {
                return _.chain(availablePromotions[t].PromoteTo)
                    .filter(function(tenantEnvironmentPromotion) {
                        return _.contains(selectedEnvironments, tenantEnvironmentPromotion.Id);
                    })
                    .map(function(tenantEnvironmentPromotion) {
                        return octopusRepository.Releases.getDeploymentPreview(tenantEnvironmentPromotion);
                    })
                    .value();
            })
            .flatten()
            .value();
    }

    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_deployment_create_controller.js
// module id = 4253889414894127
// module chunks = 1